package com.trevorwiebe.timesheet.admin.usermanagement.presentation

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import com.trevorwiebe.timesheet.core.domain.model.DatabaseUserModel
import com.trevorwiebe.timesheet.core.domain.model.OwnerOperator
import com.trevorwiebe.timesheet.core.presentation.common.responsiveDialogWidth

@Composable
actual fun AddEditUserDialog(
    editing: DatabaseUserModel?,
    isSaving: Boolean,
    isSendingPasswordReset: Boolean,
    passwordResetEmailSent: Boolean,
    currentUserId: String?,
    ownerOperators: List<OwnerOperator>,
    onDismiss: () -> Unit,
    onCreate: (UserManagementEvent.OnCreateUser) -> Unit,
    onUpdate: (UserManagementEvent.OnUpdateUser) -> Unit,
    onSendPasswordReset: () -> Unit,
    onDelete: () -> Unit,
    onRestore: () -> Unit,
) {
    Dialog(onDismissRequest = onDismiss) {
        Card(modifier = Modifier.responsiveDialogWidth(), shape = RoundedCornerShape(16.dp)) {
            AddEditUserFormContent(
                editing = editing,
                isSaving = isSaving,
                isSendingPasswordReset = isSendingPasswordReset,
                passwordResetEmailSent = passwordResetEmailSent,
                currentUserId = currentUserId,
                ownerOperators = ownerOperators,
                onDismiss = onDismiss,
                onCreate = onCreate,
                onUpdate = onUpdate,
                onSendPasswordReset = onSendPasswordReset,
                onDelete = onDelete,
                onRestore = onRestore,
            )
        }
    }
}
